import createReducer from "../../createReducer";
import { zapierZapsHandlers } from "../handlers";
import { IZapierDataState } from "../types";

export const zapierData: IZapierDataState = {
    zaps: null,
    message: "",
    isLoading: false
};

export default createReducer(zapierData, zapierZapsHandlers);
